module.exports = __webpack_public_path__ + "static/img/s122.34a758af.png";